// ==================================================================================================
//
// Profile Fee History Table
//
// ==================================================================================================
import { forEach } from 'lodash'
import m from 'moment'
import {getClassHistory } from '../utilities'

const DATETIME_FORMAT = 'YYYY-MM-DD h:mma'
const DATE_FORMAT = 'YYYY-MM-DD'

const tableFeeHistory = () => {
  const props = {
    dateFormat: 'D-M-YYYY',
    dateRangeFormat: 'MMM D, YYYY',
    dateRangeAriaFormat: 'MMMM D, YYYY',
    startDate: m().subtract(2, 'weeks').startOf('day'),
    endDate: m().endOf('day'),
    data: [],
  };

  let els = {};

  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.wrapper = '#js-fee-history'
    els.$dateRange = $('.js-fee-history-date-range')
    els.$dateRangeFilter = $('.js-fee-history-date-range-filter')
    els.$feeHistoryTable = $('.js-fee-history-table-body')
    els.$datepicker = $('.js-fee-history-datepicker')
    els.$graphToggles = $('.js-graph-toggle')
    els.$feeTableFilter = $('#fee-table-filter')
  }

  // Update date range
  // ------------------------------------------------
  const updateUIDate = () => {
    const {dateRangeFormat, dateRangeAriaFormat, startDate, endDate} = props
    const dateRangeText = startDate.format(dateRangeFormat) + ' - ' + endDate.format(dateRangeFormat)
    const dateRangeFilterText = startDate.format(dateRangeFormat) + ' | ' + endDate.format(dateRangeFormat)
    const dateRangeAria = startDate.format(dateRangeAriaFormat) + ' to ' + endDate.format(dateRangeAriaFormat)

    els.$dateRange.text(dateRangeText)
    els.$dateRangeFilter.text(dateRangeFilterText)
    els.$dateRange.siblings('.js-fee-history-date-range-for-aria').text(dateRangeAria)
  }

  const updateDateRange = (start, end = m().subtract(1, 'days').startOf('day')) => {
    props.startDate = start
    props.endDate = end
    updateUIDate()
    getClassHistoryData();
  }

  const updateTable = () => {
    els.$feeHistoryTable.empty()
    els.$feeHistoryTable.append($(rowTemplate(props.data)))
    setTimeout(() => {
      $('.status-filter-wrapper').css('bottom', '50px');
    }, 500);
  }

  const renderFeeDate = val => m(val, DATETIME_FORMAT).format('MMMM D, YYYY') + `<span class="timeSpan">${m(val, DATETIME_FORMAT).format('/ h:mm a')}</span>`

  const rowTemplate = rowData => {
    return rowData.reduce((acc, cur) => {

      return acc + `
        <div class="member-profile-fee-history__row" aria-label="Fee history item">
          <p class="member-profile-fee-history__row__class type--d6 type--charcoal--80">
            <span class="is-visually-hidden">Class:</span>
            <span>${cur.program_name}</span>
          </p>
          <p class="member-profile-fee-history__row__date-time type--d6 type--charcoal--80">
            <span class="is-visually-hidden">Date/Time:</span>
            <span>
              ${m(cur.occurrenceStartTime, DATETIME_FORMAT).format('MMM DD, YYYY')}
              <span class="timeSpan">${m(cur.occurrenceStartTime, DATETIME_FORMAT).format('/ h:mm a')}</span>
            </span>
          </p>
          <p class="member-profile-fee-history__row__location type--d6 type--charcoal--80">
            <span class="is-visually-hidden">Location:</span>
            <span>${cur.locationName}</span>
          </p>
          <p class="member-profile-fee-history__row__fee-type type--d6 type--charcoal--80">
            <span class="is-visually-hidden">Status:</span>
            <span>${ cur.status && cur.status.split("_").join(" ") }</span>
          </p>
          <p class="member-profile-fee-history__row__incurred type--d6 type--charcoal--80">
            <span class="is-visually-hidden">Fee Incurred?:</span>
            <span>
              ${ cur.fee_incurred_at ? renderFeeDate(cur.occurrenceStartTime) : "-" }
            </span>
          </p>
          <p class="member-profile-fee-history__row__fee-amount type--d6 type--charcoal--80">
            <span class="is-visually-hidden">Fee ($):</span>
            <span class=${ cur.creditedDate  ? 'strikeThrough' : null }>            
            ${ 
              cur.club.no_show_late_cancel_fees ? 
                  (typeof cur.fee_amount === 'number' && !isNaN(cur.fee_amount) ?
                      Number(cur.fee_amount / 100).toLocaleString(undefined, { minimumFractionDigits: 2, aximumFractionDigits: 2 }) : "0.00") :
                  "-"
            }
            </span>
          </p>
        </div>
      `
    }, '')
  }

  const toggleActiveUIViewItem = (e) => {
    els.$graphToggles.removeClass('is-active')
    if (e.type === 'click') {
      const $newItem = $(e.currentTarget)
      $newItem.addClass('is-active')
    } else {
      els.$datepicker.addClass('is-active')
    }
  }

  // Show table & remove error message
  // ------------------------------------------------
  const removeError = () => {
    if ($(els.wrapper).hasClass('was-removed')) {
      $('.member-profile-fee-history-message').fadeOut(500, () => {
        $('.member-profile-fee-history-message').remove()
        $(els.wrapper).removeClass('was-removed')
        $(els.wrapper).parents('.member-profile-fee-history-wrapper__interior').fadeIn(500)

        if ($(els.wrapper).hasClass('all-removed')) {
          $('.js-fee-history-table').slideDown(500)
          $(els.wrapper).removeClass('all-removed')
        }
      })
    }
  }

  // Hide table & show error message
  // ------------------------------------------------
  const showError = (hideAll, errorMessage) => {
    if (hideAll) {
      $('.js-fee-history-table').slideUp(500)
      $(els.wrapper).addClass('all-removed')
    }

    $(els.wrapper).parents('.member-profile-fee-history-wrapper__interior').slideUp(500, () => {
      // append 'narrow search' message & clear the datepicker
      $(els.wrapper).parents('.member-profile-fee-history-wrapper').append(errorMessage).hide().delay(30).slideDown(500)
    })

    // add class to denote the graph was removed
    // and don't update the date range
    $(els.wrapper).addClass('was-removed')
  }

  // On date picker change, fetch and display new data
  // -------------------------------------------------
  const onDatePickerChange = (selectedDates, instance) => {
    // only run new data if datepicker has 2 dates selected, and they are unique
    if (selectedDates.length === 2) {
      const theStart = m(selectedDates[0])
      const theEnd = m(selectedDates[(selectedDates.length === 2) ? 1 : 0])

      updateDateRange(theStart, theEnd)
      instance.clear() // clear the datepicker
    } else {
      const defaultStartDate = m().subtract(2, 'weeks').startOf('day');
      const defaultEndDate = m().startOf('day');
      updateDateRange(defaultStartDate, defaultEndDate);
    }

  }

  // Init the datepicker
  // ------------------------------------------------
  const initDatepicker = () => {
    els.datepickerElem = els.$datepicker.flatpickr({
      mode: 'range',
      appendTo: document.querySelector('.js-fee-history-datepicker-wrapper'),
      maxDate: 'today', // do not allow picking of future dates
      disableMobile: 'true',
      ariaDateFormat: 'l, F j, Y',
      onReady: (selectedDates, dateStr, instance) => {
        $('.js-fee-history-datepicker-wrapper .flatpickr-calendar').attr('aria-hidden', true)
        forEach(document.querySelectorAll('.js-fee-history-datepicker-wrapper .flatpickr-month'), month => { month.setAttribute('aria-hidden', 'true') })
        forEach(document.querySelectorAll('.js-fee-history-datepicker-wrapper .flatpickr-weekdays'), weekday => { weekday.setAttribute('aria-hidden', 'true') })
        $('.flatpickr-weekdaycontainer').css('display', 'flex')
        $('.flatpickr-weekdaycontainer').css('width', '100%')
        $('.flatpickr-prev-month').css('top', '10%')
        $('.flatpickr-next-month').css('top', '10%')
      },
      onOpen: (selectedDates, dateStr, instance) => toggleActiveUIViewItem(instance.element),
      onChange: (selectedDates, dateStr, instance) => {
        // add more specific aria label info to end date
        if (selectedDates.length === 2) {
          let selectedEndDateElem = document.querySelector('.js-fee-history-datepicker-wrapper .flatpickr-day.selected.endRange')
          if (selectedEndDateElem) {
            let selectedEndDateAriaLabel = selectedEndDateElem.getAttribute('aria-label')
            selectedEndDateElem.setAttribute('aria-label', 'End date selected ' + selectedEndDateAriaLabel)
          }
        }

        // add more specific aria label info to initial date
        if (selectedDates.length >= 1) {
          let selectedDateElem = document.querySelector('.js-fee-history-datepicker-wrapper .flatpickr-day.selected:not(.endRange)')
          if (selectedDateElem) {
            let selectedDateAriaLabel = selectedDateElem.getAttribute('aria-label')
            selectedDateElem.setAttribute('aria-label', 'Start date selected ' + selectedDateAriaLabel)
          }
        }
      },
      onClose: (selectedDates, dateStr, instance) => {
        onDatePickerChange(selectedDates, instance)

        $('.js-fee-history-datepicker-wrapper .flatpickr-calendar').attr('aria-hidden', true)
      }
    });
  }

  // Open datepicker & set to aria visible
  // ------------------------------------------------
  const openDatepicker = () => {
    els.datepickerElem.open()
    $('.js-fee-history-datepicker-wrapper .flatpickr-calendar').attr('aria-hidden', false)
    $('.js-fee-history-datepicker-wrapper .flatpickr-day.today').attr('aria-describedby', 'datepicker-hint')
    $('.js-fee-history-datepicker-wrapper .flatpickr-day.today').attr('tabindex', '1')
    $('.js-fee-history-datepicker-wrapper .flatpickr-day.today').focus()
  }

  // Get fee history data from server
  // ------------------------------------------------
  const getClassHistoryData = () => {

    const memberId = els.$feeHistoryTable.data('member-id')
    const status = els.$feeTableFilter.val()

    getClassHistory({
      status,
      memberId,
      startDate: props.startDate.format('YYYY-MM-DD'),
      endDate: props.endDate.format('YYYY-MM-DD'),
      onSuccess: data => onFeeHistorySuccess(JSON.parse(data)),
      onError: () => onFeeHistoryError()
    })
  }

  const onFeeHistorySuccess = (data) => {
    props.data = data.map(el => {
      return Object.assign(el, {
        programName: el.program_name,
        occurrenceStartTime: el.occurrence_start_time,
        locationName: el.club.name,
        feeType: el.type,
        incurredAt: el.incurred_at,
        amount: el.amount,
        creditedDate: el.credited_date
      })
    })
    if (props.data.length > 0) {
      removeError()
      updateTable()
    } else {
      $('.status-filter-wrapper').css('bottom', '40px');
      const $noDataExistsMessage = $('<div class="member-profile-fee-history-message member-profile-fee-history-message--no-data"><p class="type--center type--d6 type--charcoal-50" aria-role="alert">There were no classes in the selected date range. Please select another range.</p></div>')
      if ($('.member-profile-fee-history-message').length > 0) {
        $('.member-profile-fee-history-message').fadeOut(500, () => {
          $('.member-profile-fee-history-message').remove();
          showError(true, $noDataExistsMessage)
        })
      } else {
        showError(true, $noDataExistsMessage)
      }
    }
  }

  const onFeeHistoryError = () => {
    $('.status-filter-wrapper').css('bottom', '40px');
    const $fetchingHistoryFailedMessage = $('<div class="member-profile-fee-history-message member-profile-fee-history-message--fetching-failed"><p class="type--center type--d6 type--charcoal-50" aria-role="alert">Something went wrong while fetching fee history. Please try again later.</p></div>')

    if ($('.member-profile-fee-history-message').length > 0) {
      $('.member-profile-fee-history-message').fadeOut(500, () => {
        $('.member-profile-fee-history-message').remove()
        showError(true, $fetchingHistoryFailedMessage)
      })
    } else {
      showError(true, $fetchingHistoryFailedMessage)
    }
  }



  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // Add your event handlers here
    initDatepicker()
    updateUIDate()
    els.$datepicker.on('click', openDatepicker)
    els.$feeTableFilter.on('change', getClassHistoryData)


    props.isEnabled = true;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here
    els.$datepicker.off('click', openDatepicker)

    props.isEnabled = false;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren();
    enable();
    getClassHistoryData();
  }

  return {
    init,
    enable,
    disable
  };
}

export default tableFeeHistory;
